/**
 * Created by Christof Sander on 25.01.2017.
 */

const utils = require('../../../lib/utils')

module.exports = {
	methods: {
		dataDealer: function(){
			var self = this;
			this.closest('base_mediaManagement_imageAssignmentDetails_imageAssignmentDetails', function(imageAssignmentDetailsComponent){
				if(imageAssignmentDetailsComponent.resourceData){
					self.resourceData = imageAssignmentDetailsComponent.resourceData;
				}
			});
		},

		sanitizeResources: function(){
			if(this.resourceData.rendered){
				var images = this.resourceData;
				var newImages = {};
				var device;
				var breakPoint;
				utils.forEach(images.rendered, function(renderedImage){
					if(renderedImage.device)        device = renderedImage.device;
					else                            device = 'others';
					if(renderedImage.breakPoint)    breakPoint = renderedImage.breakPoint;
					else                            breakPoint = 'others';

					if(!newImages[device])             newImages[device] = {};
					if(!newImages[device][breakPoint]) newImages[device][breakPoint] = [];

					newImages[device][breakPoint].push(renderedImage);
				});

				this.model.images = newImages;
			}
		}
	}
};
